<template>
  
  <div :class="pageCss">

    <div class="wrapper__inner--narrow">


      <section>
        
        <h2 v-html="content.title"></h2>

        <div :class="ctaContainerClass">

          <div v-for="(cta, index) in content.ctas" :key="index" class="inner">

            <div><img :src="cta.image"></div>
            <div>{{ cta.copy }}</div>
            <div>
              <button class="default" @click="openLink(cta.url)">
                {{ cta.buttonCopy }}
                <span>
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.1 19.3" style="enable-background:new 0 0 23.1 19.3;" xml:space="preserve">
                    <polygon points="21.5,8.2 13.8,0 12.2,1.6 18.8,8.6 0,8.6 0,10.8 18.9,10.8 12.5,17.7 14.1,19.3 23.1,9.7 "/>
                  </svg>
                </span>
              </button>             
            </div>
          </div>

        </div>

      </section>

    </div>

  </div>

</template>

<script>
  
  export default {
    name: 'SectionCallToAction',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {
      pageCss() {
        return `content content__${this.content.type}`;
      },
      ctaContainerClass() {
        return `ctas ctas--${this.content.ctas.length}`;
      }
    },
    methods: {

      openLink(url) {
        window.open(url);
      }

    }
  };
</script>